module.exports = __webpack_public_path__ + "img/img-e510f4.png";